<script setup lang="ts">
import { useAiChatStore } from '@/stores/ai-chat'
import { Button } from '@kyoto2/components/ui/button'
import { TriangleAlert } from 'lucide-vue-next'

const store = useAiChatStore()

// 'dead' means the wire itself went quiet (missed heartbeats / offline), so a
// plain Stop leaves nothing worth keeping — offer an immediate Retry that
// replays the last send. 'slow' means the connection is alive but the model has
// produced nothing for a while (long tool call, extended thinking): the stream
// may still finish, so the primary choice is to keep waiting.
function retry() {
  store.stopStreaming()
  void store.retryLast()
}
</script>

<template>
  <div
    v-if="store.stallState !== 'none'"
    class="flex items-center gap-2 border-t px-3 py-2 text-xs text-muted-foreground"
  >
    <TriangleAlert class="size-3.5 shrink-0 text-amber-600 dark:text-amber-400" />
    <span class="min-w-0 flex-1">
      {{ store.stallState === 'dead'
        ? 'Connection appears stalled.'
        : 'Still working — nothing received from the assistant for a minute.' }}
    </span>
    <template v-if="store.stallState === 'slow'">
      <Button variant="ghost" size="sm" @click="store.keepWaiting()">Keep waiting</Button>
      <Button variant="outline" size="sm" @click="store.stopStreaming()">Stop</Button>
    </template>
    <template v-else>
      <Button variant="outline" size="sm" @click="store.stopStreaming()">Stop</Button>
      <Button v-if="store.canRetry" size="sm" @click="retry">Retry</Button>
    </template>
  </div>
</template>
